module.exports = __webpack_public_path__ + "img/banner.bdcb831e.png";